import { getClientApi } from '@frontend/api-client/api/client/slice';
import { getDraftTasksApi } from '@frontend/api-client/api/draftTasks/slice';
import { getInvitesApi } from '@frontend/api-client/api/invites/slice';
import { getPaymentsApi } from '@frontend/api-client/api/payments/slice';
import { getWaitlistsApi } from '@frontend/api-client/api/waitlists/slice';
import { baseApi } from '@frontend/web/redux';

const clientApi = getClientApi(baseApi);
const draftTasksApi = getDraftTasksApi(baseApi);
const invitesApi = getInvitesApi(baseApi);
const paymentsApi = getPaymentsApi(baseApi);
const waitlistsApi = getWaitlistsApi(baseApi);

export const {
  useClerkSSOLoginMutation,
  useCreateClientMutation,
  useFrictionlessSignupMutation,
  useFrictionlessSSOSignupMutation,
  useLazyRetrieveClientQuery,
  useLazyRetrieveClientStatusQuery,
  useLoginMutation,
  useRetrieveClientQuery,
  useRetrieveClientStatusQuery,
} = clientApi;

export const { useLazyListDraftTasksQuery } = draftTasksApi;
export const { useLazyRetrieveInviteQuery } = invitesApi;
export const { useLazyRetrievePromotionDetailsQuery } = paymentsApi;
export const { useRetrieveWaitlistStatusQuery } = waitlistsApi;
